import { CommonService } from './../../../services/common/common.service';
// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';
// Service Class
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { CppCoiRequestService } from '../../../services/cpp-coi-request/cpp-coi-request.service';

// Class
import { CPPItemsFilter } from './../../../models/CPP/CPPItemsFilter';
import { CPPCOIOrderSummaryVM } from './../../../models/COI/CPPCOIOrderSummaryVM';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { MasterConstants } from './../../../common/constants/master-constants';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { MobilePDFVM } from '../../../models/CPP/MobilePDFVM';
import { Subscription } from 'rxjs';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-cpp-coi-request-confirmation',
  templateUrl: './cpp-coi-request-confirmation.component.html',
  styleUrls: ['./cpp-coi-request-confirmation.component.scss']
})
export class CppCoiRequestConfirmationComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  emails: any;
  emailButtonClicked = false;
  configurationMessage: any[];
  errorData: any[];
  ifAnyError = false;
  statusNotice = '';
  deliveryDate: Date;
  webOrderNumber = '';
  splitId: number;
  showErrorItems: boolean;
  showPDFIcon: boolean;
  totalOrderCost = 0;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  orderStatus = '';
  filter: any = new CPPItemsFilter();
  cppProductItemsDataSource: any[];
  shipToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  deliverToAccountdetails: any = {};
  ascAccountDetails: any = {};
  dsmAccountDetails: any = {};
  statusNoticeData: any = {};
  showBackToCppLanding: boolean;
  pdfDataObject: any;
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  jdeorderNumber = '';
  customerPONumber = '';
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  @ViewChild('contractsPaginator', { read: MatPaginator }) contractsPaginator: MatPaginator;
  isRedirectedFromPlacedOrder = false;
  readOnlyAccess = false;
  filter2: MobilePDFVM = new MobilePDFVM();
  basePdfData: string;
  specialInstructionText: string;
  public bulkContactName: any;
  public bulkContactNumber: any;
  public isBulkItemAvailable = false;
  public packagedContactName: any;
  public packagedContactNumber: any;
  public packagedDeliveryInst: any;
  public isPackagedItemAvailable = false;

  constructor(private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private cppCoiRequestService: CppCoiRequestService,
    private commonService: CommonService) { }

  ngOnInit() {
    this.loaderService.setLoaderStatus(true);
    const summaryScreenFrom = this.cppCoiRequestService.redirectFrom;
    if (summaryScreenFrom === 'placeOrder') {
      this.isRedirectedFromPlacedOrder = true;
      this.cppCoiRequestService.setRedirectionFrom('');
    }
    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
    }
    if (this.cppCoiRequestService.webOrderNumberAndSplitId) {
      var data = this.cppCoiRequestService.webOrderNumberAndSplitId.split('~');
      this.webOrderNumber = data[0];
      this.splitId = +data[1];
      this.showErrorItems = data[2] === 'error' ? true : false;
      this.showPDFIcon = this.showErrorItems;
      this.showBackToCppLanding = data[3] === 'CPPLanding' ? true : false;
      this.getOrderSummaryData();
    } else {
      this.router.navigate(['/cpp/ cpp-coi-landing']);
      this.commonService.currentTabIndex.next(0);
    }

    this.statusNoticeData.withoutSplitNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_STATUS');
    this.statusNoticeData.splitNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_SPLIT_STATUS');
    this.statusNoticeData.errorNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_ERROR_STATUS');
    this.statusNoticeData.partialSplitStatus = this.configurationMessage.filter(x => x.id === 'PARTIAL_SPLIT');

    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.COI_ORDER);
  }

  //
  getErrorMessagesForProduct(item) {
    let message = '';
    const configMessage = this.configurationMessage.filter(x => x.id === 'SPLIT_ERROR');
    if (configMessage && configMessage.length > 0) {
      message = configMessage[0].value;
    }
    return message;
  }
  //
  getDeliveryDate(item: any) {
    let data;
    if (item && item.productDetail && item.productDetail.length > 0) {
      data = item.productDetail[0].desiredDeliveryDate;
    }
    return data;
  }

  getDeliveryDateReason(item: any) {
    let data;
    if (item && item.productDetail && item.productDetail.length > 0) {
      data = item.productDetail[0].deliveryDateChangeReason;
    }
    return data;
  }

  getTooltipText(item: any): string {
    const tooltipValue = this.getDeliveryDateReason(item);
    return `Arrival Date Reason Change\n${tooltipValue}`;
  }

  openEmailSection() {
    this.emailButtonClicked = true;
  }
  //
  sendEmail() {
    this.emailButtonClicked = false;
  }
  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.prepayContractOuter').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  generatedPdf(webOrderNumber: any) {
    if (webOrderNumber) {
      this.cppCoiRequestService.generatePdf(webOrderNumber);
    }
  }

  // get Order Summary Data for display and PDF
  getOrderSummaryData() {
    this.subscription.push(this.cppCoiRequestService.getOrderSummaryDetails(this.webOrderNumber).subscribe((result: CPPCOIOrderSummaryVM) => {
      this.pdfDataObject = result;

      result.splitDetails.forEach(x => {
        x.productDetail.forEach(prod => {
          if (prod.bulkPackaged.toUpperCase() === "BULK") {
            this.bulkContactName = this.pdfDataObject.bulkContactName;
            this.bulkContactNumber = this.pdfDataObject.bulkContactPhoneNumber;
            this.isBulkItemAvailable = true;
          }
          if (prod.bulkPackaged.toUpperCase() === "PACKAGED") {
            this.packagedContactName = this.pdfDataObject.packagedContactName;
            this.packagedContactNumber = this.pdfDataObject.packagedContactNumber;
            this.packagedDeliveryInst = this.pdfDataObject.packagedDeliveryInst;
            this.isPackagedItemAvailable = true;
          }
        });
      });

      if (result && result.splitDetails && result.splitDetails.length > 0 && result.splitDetails.filter(x => x.splitId == 1).length > 0) {
        this.showPDFIcon = false;
      } else {
        this.showPDFIcon = true;
      }
      if (result && result.splitDetails && result.splitDetails.length > 0) {
        if (result.splitDetails.length == 1 && !result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.withoutSplitNoticeStatus[0].value;
        }
        else if (result.splitDetails.length > 1 && !result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.splitNoticeStatus[0].value;
        }
        else if (result.splitDetails.length > 1 && result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.partialSplitStatus[0].value;
        }
        if (this.showErrorItems) {
          this.cppProductItemsDataSource = result.splitDetails.filter(x => x.splitId == 1);
          if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.length > 0) {
            this.totalNumbersOfOrder = this.cppProductItemsDataSource.length;
            this.cppProductItemsDataSource.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.originalOrderQuantity = x.originalOrderQuantity ? x.originalOrderQuantity.toFixed(this.commonService.countDecimals(x.originalOrderQuantity)) : x.originalOrderQuantity;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
          }
          this.statusNotice = this.statusNoticeData.errorNoticeStatus[0].value;
        } else {
          this.cppProductItemsDataSource = result.splitDetails;
          if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.length > 0) {
            this.totalNumbersOfOrder = this.cppProductItemsDataSource.length;
            this.cppProductItemsDataSource.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.originalOrderQuantity = x.originalOrderQuantity ? x.originalOrderQuantity.toFixed(this.commonService.countDecimals(x.originalOrderQuantity)) : x.originalOrderQuantity;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
          }
          this.errorData = result.splitDetails.filter(x => x.splitId == 1);
          if (this.errorData && this.errorData.length > 0) {
            this.ifAnyError = true;
            if (this.errorData.length == result.splitDetails.length) {
              this.statusNotice = this.statusNoticeData.errorNoticeStatus[0].value;
            }
          }
        }

        this.webOrderNumber = result.webOrderNumber;
        this.specialInstructionText = result.specialInstructionText;
        this.orderStatus = result.orderStatus;
        this.deliveryDate = result.desiredDeliveryDate;
        this.shipToAccountdetails.AccountNumber = result.accountNumber;
        this.shipToAccountdetails.AccountName = result.accountName;
        this.shipToAccountdetails.Address1 = result.accountAddress1;
        this.shipToAccountdetails.Address2 = result.accountAddress2;
        this.shipToAccountdetails.AccountCity = result.accountCity;
        this.shipToAccountdetails.AccountState = result.accountState;
        this.shipToAccountdetails.AccountZipCode = result.accountZipCode;
        this.shipToAccountdetails.HeaderText = result.headerText;
        this.shipToAccountdetails.InstructionType = result.instructionType;
        this.shipToAccountdetails.CustomerPickUp = result.customerPickUp == 'N' ? 'NO' : 'YES';
        this.shipToAccountdetails.PlacedByName = result.placedByName;
        this.shipToAccountdetails.CreatedOn = result.createdOn;

        // this.deliverToAccountdetails
        if (result.deliverToDetail) {
          this.deliverToAccountdetails.AccountNumber = result.deliverToDetail.accountNo;
          this.deliverToAccountdetails.AccountName = result.deliverToDetail.accountName;
          this.deliverToAccountdetails.Address1 = result.deliverToDetail.address1;
          this.deliverToAccountdetails.AccountCity = result.deliverToDetail.city;
          this.deliverToAccountdetails.AccountState = result.deliverToDetail.state;
          this.deliverToAccountdetails.AccountZipCode = result.deliverToDetail.zipCode;
        }

        // this.soldToAccountdetails
        if (result.soldToDetail) {
          this.soldToAccountdetails.AccountNumber = result.soldToDetail.accountNo;
          this.soldToAccountdetails.AccountName = result.soldToDetail.accountName;
          this.soldToAccountdetails.Address1 = result.soldToDetail.address1;
          this.soldToAccountdetails.Address2 = result.soldToDetail.address2.replace('<br>', '');
          this.soldToAccountdetails.AccountCity = result.soldToDetail.city;
          this.soldToAccountdetails.AccountState = result.soldToDetail.state;
          this.soldToAccountdetails.AccountZipCode = result.soldToDetail.zipCode;
        }

        if (result.ascDetail) {
          this.ascAccountDetails.AccountName = result.ascDetail.ascName;
          this.ascAccountDetails.AscAddress1 = result.ascDetail.ascAddress1;
          this.ascAccountDetails.AscAddress2 = result.ascDetail.ascAddress2;
          this.ascAccountDetails.Phone = result.ascDetail.primaryPhone;
          this.ascAccountDetails.Email = result.ascDetail.emailAddress;
          this.ascAccountDetails.City = result.ascDetail.city;
          this.ascAccountDetails.State = result.ascDetail.state;
          this.ascAccountDetails.ZipCode = result.ascDetail.zipCode;
        }

        if (result.dsmDetail) {
          this.dsmAccountDetails.AccountName = result.dsmDetail.dsmAccountName;
          this.dsmAccountDetails.dsmAddress1 = result.dsmDetail.dsmAddress1;
          this.dsmAccountDetails.Phone = result.dsmDetail.primaryPhone;
          this.dsmAccountDetails.Email = result.dsmDetail.emailAddress;
          this.dsmAccountDetails.City = result.dsmDetail.city;
          this.dsmAccountDetails.State = result.dsmDetail.state;
          this.dsmAccountDetails.ZipCode = result.dsmDetail.zipCode;
        }

        this.jdeorderNumber = result.jdeorderNumber;
        this.shipToAccountdetails.CustomerPONumber = result.custPONumber;
      }
      this.loaderService.setLoaderStatus(false);
    }));
  }
  // Navigate  to CPP landing page
  backToLandingPage() {
    this.router.navigate(['/cpp/cpp-coi-landing']);
    this.commonService.currentTabIndex.next(0);
  }

  // Navigate  to CPP error maintenance screen
  backToErrorMaintenancePage() {
    this.router.navigate(['/cpp/error-order-maintenance-dashboard']);
  }

  ngOnDestroy() {
    this.cppCoiRequestService.webOrderNumberAndSplitId = undefined;
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Create a new Cpp order(navigate to new order screen)
  createNewOrder() {
    this.cppCoiRequestService.setCoiOrderIdCPP(0);
    this.router.navigate(['/cpp/cpp-coi-request-entry']);
  }
}
